"use strict";

var _Object$keys2 = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQuestionType = getQuestionType;
exports.default = exports.TEMPLATE = exports.DIRECTION = exports.QUESTION_TYPES = exports.TYPES = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

function ownKeys(object, enumerableOnly) { var keys = _Object$keys2(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty2(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Reducer = function Reducer(state, action) {
  var _context;

  // TYPES.ADD
  var index = (0, _keys.default)(state).length; // TYPES.MOVE

  var _action$payload = action.payload,
      direction = _action$payload.direction,
      i = _action$payload.index;
  var props = (0, _values.default)(state);
  var to = direction === "UP" ? i - 1 : i + 1;

  switch (action.type) {
    case TYPES.ADD:
      return _objectSpread(_objectSpread({}, state), {}, (0, _defineProperty2.default)({}, index, action.payload));

    case TYPES.MOVE:
      if (direction === "UP" && to < 0) return state;
      if (direction === "DOWN" && to >= props.length) return state;
      var f = (0, _splice.default)(props).call(props, i, 1)[0];
      (0, _splice.default)(props).call(props, to, 0, f);
      return _objectSpread({}, props);

    case TYPES.DELETE:
      return (0, _assign.default)({}, (0, _filter.default)(_context = (0, _values.default)(state)).call(_context, function (v, k) {
        return k !== action.payload;
      }));

    case TYPES.MARK_QUESTION_ORIENTATION:
      return _objectSpread(_objectSpread({}, state), {}, (0, _defineProperty2.default)({}, action.payload.index, _objectSpread(_objectSpread({}, state[action.payload.index]), {}, {
        "ui:options": {
          inline: action.payload.checked
        }
      })));

    default:
      return state;
  }
};

var TYPES = {
  ADD: "ADD",
  MOVE: "MOVE",
  DELETE: "DELETE",
  MARK_QUESTION_ORIENTATION: "MARK_QUESTION_ORIENTATION"
};
exports.TYPES = TYPES;
var QUESTION_TYPES = {
  RADIO: "RADIO",
  CHECKBOX: "CHECKBOX",
  OPEN_ENDED: "OPEN_ENDED"
};
exports.QUESTION_TYPES = QUESTION_TYPES;
var DIRECTION = {
  UP: "UP",
  DOWNN: "DOWN"
};
exports.DIRECTION = DIRECTION;
var TEMPLATE = {
  RADIO: {
    "ui:widget": "radio",
    "ui:options": {
      inline: true
    }
  },
  CHECKBOX: {
    "ui:widget": "checkboxes",
    "ui:options": {
      inline: true
    }
  },
  OPEN_ENDED: {
    "ui:emptyValue": ""
  }
};
exports.TEMPLATE = TEMPLATE;

function getQuestionType(widget) {
  if (!widget) return QUESTION_TYPES.OPEN_ENDED;
  if (widget === "radio") return QUESTION_TYPES.RADIO;
  if (widget === "checkboxes") return QUESTION_TYPES.CHECKBOX;
}

var _default = Reducer;
exports.default = _default;